import truncateText from './truncateText';

export default truncateText;
